import { set } from 'react-hook-form';
import { BankStatementState } from '../type';
import { createSlice } from '@reduxjs/toolkit';

const InitialState: BankStatementState = {
  bankStatementData: [],
  bankStatementRowData: [],
  bankStatementNumbers: [],
  bankStatementStatus: false
};

const bankStatementSlice = createSlice({
  name: 'bankStatement',
  initialState: InitialState,
  reducers: {
    setBankStatementStatus(state, action) {
      state.bankStatementStatus = action.payload;
    },
    setBankStatementData(state, action) {
      state.bankStatementData = action.payload;
    },
    setBankStatementRowData(state, action) {
      state.bankStatementRowData = action.payload;
    },
    setBankStatementNumbers(state, action) {
      state.bankStatementNumbers = action.payload;
    }
  }
});

export const {
  setBankStatementStatus,
  setBankStatementData,
  setBankStatementRowData,
  setBankStatementNumbers
} = bankStatementSlice.actions;

export default bankStatementSlice.reducer;
